// FAQ hub: category pills + live search over <details> items.
class FaqHub extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
    this.pills = Array.from(this.querySelectorAll('[data-faq-category]'));
    this.search = this.querySelector('[data-faq-search]');
    this.empty = this.querySelector('[data-faq-empty]');
    this.category = 'all';
    this.pills.forEach((pill) => pill.addEventListener('click', () => {
      this.category = pill.dataset.faqCategory;
      this.pills.forEach((p) => {
        p.classList.toggle('is-active', p === pill);
        p.setAttribute('aria-pressed', p === pill);
      });
      this.apply();
    }));
    this.search?.addEventListener('input', () => this.apply());
    this.items.forEach((item) => item.addEventListener('toggle', () => {
      if (item.open) this.items.forEach((other) => { if (other !== item) other.open = false; });
    }));
  }

  apply() {
    const term = (this.search?.value || '').trim().toLowerCase();
    let visible = 0;
    this.items.forEach((item) => {
      const matchesCategory = this.category === 'all' || item.dataset.category === this.category;
      const matchesTerm = !term || item.textContent.toLowerCase().includes(term);
      item.hidden = !(matchesCategory && matchesTerm);
      if (!item.hidden) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible > 0;
  }
}
if (!customElements.get('faq-hub')) customElements.define('faq-hub', FaqHub);
